export const PREVIEW_CACHE_BUST_PARAM = '__preview_refresh';
export const PREVIEW_CACHE_BUST_KEY = '__preview_cache_busted';

export function hasPreviewCacheBustParam(search: string): boolean {
  return new URLSearchParams(search).has(PREVIEW_CACHE_BUST_PARAM);
}

export function shouldForcePreviewRefresh(search: string, wasRefreshed: boolean): boolean {
  return !wasRefreshed && !hasPreviewCacheBustParam(search);
}

export function buildPreviewCacheBustUrl(currentHref: string, now = Date.now()): string {
  const url = new URL(currentHref);
  url.searchParams.set(PREVIEW_CACHE_BUST_PARAM, String(now));
  return url.toString();
}

export function stripPreviewCacheBustParam(currentHref: string): string {
  const url = new URL(currentHref);
  url.searchParams.delete(PREVIEW_CACHE_BUST_PARAM);
  return `${url.pathname}${url.search}${url.hash}`;
}
